import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const forwarderApiContract = c.router({
  authenticate: {
    method: 'POST',
    path: '/forwarder-api/authenticate',
    body: z.object({
      email: z.string(),
      password: z.string(),
    }),
    responses: {
      200: z.object({
        token: z.string(),
        expirationTime: z.number(),
      }),
    },
  },
  getApiAccessInfo: {
    method: 'GET',
    path: '/forwarder-api/get-api-access-info',
    responses: {
      200: z.object({
        apiAccess: z.object({
          apiAccess: z.boolean(),
          templates: z.array(z.any()),
          customers: z.array(z.any()),
        }),
      }),
    },
  },
  getTemplates: {
    method: 'GET',
    path: '/forwarder-api/templates',
    responses: {
      200: z.object({
        data: z.array(z.any()),
      }),
    },
  },
  getCustomers: {
    method: 'GET',
    path: '/forwarder-api/customers',
    responses: {
      200: z.object({
        data: z.array(z.any()),
      }),
    },
  },
  syncBatch: {
    method: 'GET',
    path: '/forwarder-api/sync-batch/:externalId',
    pathParams: z.object({
      externalId: z.string(),
    }),
    responses: {
      200: z.object({
        data: z.object({
          declarations: z.array(
            z.object({
              lrn: z.string().optional(),
              sequence: z.number().optional(),
              status: z.string().optional(),
              customsState: z.any().optional(),
            }),
          ),
        }),
      }),
    },
  },
  syncDeclarations: {
    method: 'GET',
    path: '/forwarder-api/sync-declarations/:lastSyncTimestamp',
    pathParams: z.object({
      lastSyncTimestamp: z.string().datetime(),
    }),
    responses: {
      200: z.object({
        data: z.array(z.any()),
      }),
    },
  },
  getCustomsReport: {
    method: 'GET',
    path: '/forwarder-api/get-customs-report/:externalId',
    pathParams: z.object({
      externalId: z.string(),
    }),
    responses: {
      200: z.any(),
    },
  },
  downloadCustomsReport: {
    method: 'GET',
    path: '/forwarder-api/download-customs-report/:externalId',
    pathParams: z.object({
      externalId: z.string(),
    }),
    responses: {
      200: z.any(),
    },
  },
  transferBatch: {
    method: 'POST',
    path: '/forwarder-api/transfer-batch',
    body: z.object({
      customerExternalId: z.string(),
      templateExternalId: z.string(),
    }),
    contentType: 'multipart/form-data',
    responses: {
      200: z.object({
        message: z.string(),
      }),
    },
  },
});
